import { toODataString, State } from '@progress/kendo-data-query';


export function FixToODataString(state:State):string{
  //fix issue where toODataString would convert undefined dir to 'asc' if field held a value other than ""
  if (state && state.sort && state.sort.length>0) {
    const sort = state.sort[0];
    if (sort.dir == undefined) {
      sort.field="";
      state.sort=[];
    }
  }
  return toODataString(state);

}
